type UniversignReadingErrorMessageId = 'msg1' | 'msg2' | 'msg3' | 'msg4' | 'msg5' | 'msg6';

// Erreur de lecture Universign → message client (cf. mapping produit du push arbitrage).
const MESSAGE_IDS: Record<string, UniversignReadingErrorMessageId> = {
  GENERAL_APPEARANCE_FAILURE: 'msg1',
  GENERAL_APPAREANCE_FAILURE: 'msg1',
  DOCUMENT_COPY_FAILURE: 'msg2',
  '[opticalLine1 too short, opticalLine2 too short]': 'msg3',
  '[notAfter too short]': 'msg3',
  TEXT_EXTRACTION_FAILURE: 'msg4',
  "The ID document's photos are not images.": 'msg4',
  CLASSIFICATION_FAILURE: 'msg5',
};

/**
 * Message à afficher (sous `justificatifsUniversign.readingErrors`) pour une erreur de lecture
 * de la pièce d'identité. Toute erreur absente du mapping (AIDOS, échec technique, motif null…) → MSG-6.
 */
const getUniversignReadingErrorMessageId = (reasonMessage: string | null): UniversignReadingErrorMessageId =>
  (reasonMessage && MESSAGE_IDS[reasonMessage]) || 'msg6';

export type { UniversignReadingErrorMessageId };
export default getUniversignReadingErrorMessageId;
